import AppCard from '@crema/core/AppCard'
import AppScrollbar from '@crema/core/AppScrollbar'
import { ArrowBack } from '@mui/icons-material'
import { Box, Divider, IconButton, Stack, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { fetchError, fetchSuccess, showMessage } from 'redux/actions'
import { API } from 'shared/constants/AppEnums'
import DialogKonfirmasi from 'shared/components/DialogKonfirmasi'
import { onChangeFilter, onRejectDokumenDigisign } from 'redux/actions/DigitalSign'
import { useAuthUser } from '@crema/utility/AuthHooks'

const SignDokumenPk = () => {
    const { detail } = useSelector(state => state.digiSign)
    const { pathname } = useLocation()
    const dispatch = useDispatch()
    const navigation = useNavigate()
    const [toggleReject, setToggleReject] = useState(false)
    const { user } = useAuthUser()
    const isBypass = user.roles_coofis.some(item => item.state === 'BYPASS_PASSPHRASE')


    useEffect(() => {
        window.addEventListener("message", function (event) {
            if (event.data.status === 'berhasil') {
                dispatch(showMessage(event.data.message))
                localStorage.removeItem('attachment')
                localStorage.removeItem('id_document')
                localStorage.removeItem('url')
                localStorage.removeItem('label')
                localStorage.removeItem('type')
                localStorage.removeItem('nip')
                
                dispatch(onChangeFilter('completed'))
                setTimeout(() => {
                    navigation(`/apps/dokumen-pk`)
                }, 3000)
            } else if (event.data.status === 'error') {
                dispatch(fetchError(event.data.message))
            } else if (event.data.status === 'reject') {
                setToggleReject(true)
            }
        });
    }, [window.addEventListener])

    useEffect(() => {
        if (pathname === '/apps/dokumen-pk/tanda-tangan') {
            const iframe = document.querySelector("iframe");
            if (detail !== null) {
                localStorage.setItem('attachment', detail.attachments[0].file)
                localStorage.setItem('id_document', detail.id)
                localStorage.setItem('url', API.PUT_INPROGRESS_DOKUMENLAIN_DIGISIGN)
                localStorage.setItem('label', detail.label)
                localStorage.setItem('type', 'dokumen-pk')
                localStorage.setItem('nip', user.nip)
                localStorage.setItem('isBypass', isBypass)

            }

            iframe.contentWindow.postMessage({
                attachment: detail !== null ? detail.attachments[0].file : localStorage.getItem('attachment'),
                id_document: detail !== null ? detail.id : localStorage.getItem('id_document'),
                url: API.PUT_INPROGRESS_DOKUMENLAIN_DIGISIGN,
                label: detail !== null ? detail.label : localStorage.getItem('label'),
                type: 'dokumen-pk',
                nip: user.nip,
                isBypass: isBypass

            }, '*')
        }
    }, [pathname])

    const handleReject = (status = 0) => {
        if (status === 1) {
            dispatch(onRejectDokumenDigisign({ id_documents: [detail.id] }))
            setTimeout(() => {
                dispatch(onChangeFilter('rejected'))
                navigation('/apps/dokumen-pk')
            }, 2000)
            setToggleReject(false)
        } else {
            setToggleReject(false)
        }
    }

    return (
        // detail !== null ? (
        //     <Stack direction='column' spacing={4} height={'100% !important'}>
        //         <AppCard sxStyle={{ backgroundColor: 'white !important', height: '100% !important' }}>
        //             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        //                 <Box>
        //                     <Tooltip title={'Kembali'} placement='top' arrow>
        //                         <IconButton onClick={() => navigation(-1)}>
        //                             <ArrowBack />
        //                         </IconButton>
        //                     </Tooltip>
        //                 </Box>
        //             </Box>
        //             <iframe
        //                 style={{ width: '100%', height: '100%', minHeight: '70vh', border: 0, }}
        //                 src={"/assets/pdfViewer/index.html"}
        //             >
        //             </iframe>
        //         </AppCard>
        //     </Stack>
        // ) : null
        <Stack direction='column' spacing={4} height={'100% !important'}>
            <AppCard sxStyle={{ backgroundColor: 'white !important', height: '100% !important' }} contentStyle={{ display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                        <Tooltip title={'Kembali'} placement='top' arrow>
                            <IconButton onClick={() => navigation(-1)}>
                                <ArrowBack />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>

                <Divider sx={{ mt: 2 }} />

                <iframe
                    style={{ flex: 1, border: 0, }}
                    src={"/assets/pdfViewer/index.html"}
                >
                </iframe>

                <DialogKonfirmasi
                    open={toggleReject}
                    handleClose={handleReject}
                    labelPesan='Tolak Dokumen'
                    isiPesan={'Apakah anda yakin akan menolak dokumen berikut?'}
                    labelTombol='Tolak'
                />
            </AppCard>
        </Stack>
    )
}

export default SignDokumenPk